import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2838eebf&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2838eebf&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2838eebf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2838eebf')) {
      api.createRecord('2838eebf', component.options)
    } else {
      api.reload('2838eebf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2838eebf&scoped=true&", function () {
      api.rerender('2838eebf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rule/msend/index.vue"
export default component.exports